import * as React from 'react';
import { toast } from 'react-toastify';

import { Button, Modal, Grid } from 'antd';

import { useMutation } from '@tanstack/react-query';
import { Formik, Form as FormikForm } from 'formik';
import type { AddressFormKit, AddressFormValues, AddressKitInfo } from 'v2/interfaces/addressKit';
import kitService from 'v2/services/kit';

import Address, { mapCity } from './Address';
import ConfirmUpdateAddress from './ConfirmUpdateAddress';
import ModalConfirmAddressSchema from './validation';

const { useBreakpoint } = Grid;

type ConfirmAddressToKitsProps = {
  isOpen: boolean;
  setIsOpen: (prev: boolean) => void;
  data: AddressKitInfo;
};

const ConfirmAddressToKits = ({ isOpen, setIsOpen, data: { address, name } }: ConfirmAddressToKitsProps) => {
  const screens = useBreakpoint();
  const isMobile = !screens.sm;
  const [isOpenConfirmUpdateAddress, setIsOpenConfirmUpdateAddress] = React.useState(false);

  const saveNewAddressToKit = useMutation({
    mutationFn: (data: AddressFormKit) => {
      const formattedData = {
        ...data,
        number: data.number || null
      };

      return kitService.saveNewAddressToKit(formattedData);
    }
  });

  const onSubmit = async (values: AddressFormValues) => {
    try {
      await saveNewAddressToKit.mutateAsync({
        ...values,
        city: typeof values.city === 'string' ? values.city : values.city.value
      });
      setIsOpen(false);
      setIsOpenConfirmUpdateAddress(true);
    } catch (error) {
      console.error(error);
      toast.error(error);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Formik
        initialValues={{
          zipcode: address?.zipcode || '',
          street: address?.street || '',
          neighborhood: address?.neighborhood || '',
          state: address?.state || '',
          number: address?.number || '',
          noNumber: address?.number === null,
          city: address?.city ? mapCity(address?.city, address?.state) : null,
          additionalInfo: address?.additionalInfo || '',
          phone: address?.phone || '',
          cpf: address?.cpf || ''
        }}
        onSubmit={onSubmit}
        validationSchema={ModalConfirmAddressSchema}
      >
        {formikProps => {
          return (
            <>
              <FormikForm>
                <Modal
                  open={isOpen}
                  onCancel={handleClose}
                  width={isMobile ? '100vw' : 900}
                  title='📬 Atualizar endereço de entrega!'
                  closable
                  footer={
                    <div className='flex justify-end gap-2.5'>
                      <Button onClick={handleClose} size='large' disabled={saveNewAddressToKit.isPending}>
                        Cancelar
                      </Button>
                      <Button
                        type='primary'
                        size='large'
                        htmlType='submit'
                        disabled={saveNewAddressToKit.isPending}
                        onClick={formikProps.submitForm}
                      >
                        Salvar endereço de entrega!
                      </Button>
                    </div>
                  }
                >
                  <p className='text-text mb-5! text-base font-bold'>
                    <strong>Informe seu novo endereço de entrega:</strong>
                  </p>
                  <div className='flex flex-col gap-3'>
                    <Address />
                  </div>
                </Modal>
              </FormikForm>
            </>
          );
        }}
      </Formik>
      <ConfirmUpdateAddress isOpen={isOpenConfirmUpdateAddress} setIsOpen={setIsOpenConfirmUpdateAddress} name={name} />
    </>
  );
};

export default ConfirmAddressToKits;
